import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import DashboardNavbar from "./DashboardNavbar";
import { useLoading } from "./LoadingContext";

function SummaryReport() {
  const [data, setData] = useState({});
  const { loading, setLoading } = useLoading();
  const [error, setError] = useState(null);
  // const [fromDate, setFromDate] = useState("");
  // const [toDate, setToDate] = useState("");
  const [candidateCurrentStatuses, setCandidateCurrentStatuses] = useState([]);
  const [candidateCurrentStatus, setCandidateCurrentStatus] = useState("");
  const [jobDescriptionOptions, setJobDescriptionOptions] = useState([]);
  const [selectedJob, setSelectedJob] = useState("");

  // Fetch data based on selected filters
  const fetchData = async () => {
    setLoading(true);
    setError(null);

    // const storedUser = localStorage.getItem("user_id");

    // const user_id = storedUser ? Number(storedUser) : null;

    // Debugging: Log retrieved values
    // console.log("Submitting JD with:", { user_id });
    const storedClient = localStorage.getItem("client");
    const storedUser = localStorage.getItem("user_id");

    // Convert stored values to numbers
    const client_id = storedClient ? Number(storedClient) : null;
    const user_id = storedUser ? Number(storedUser) : null;

    // Debugging: Log retrieved values
    console.log("Fetching data with:", { client_id, user_id });

    // Ensure client_id and user_id are valid before making the request
    if (!client_id || !user_id) {
      console.error("Missing client_id or user_id. Please log in again.");
      return;
    }

    try {
      // Construct the query parameters based on user selection
      let params = {};

      if (selectedJob) {
        const [jd_id, jd_role] = selectedJob.split(", "); // Assuming selectedJob contains JD ID and role combined
        params.jd_id = jd_id;
        params.jd_role = jd_role;
      }

      if (candidateCurrentStatus) {
        params.candidate_status = candidateCurrentStatus;
      }

      // Make API call
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/screener/metrics?client_id=${client_id}&user_id=${user_id}`,
        { params }
      );

      setData(response.data.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError(err.message);
      console.error("API error:", err);
    }
  };

  // Initial fetch of all data without filters
  useEffect(() => {
    fetchData();
  }, []);

  // Refetch data when selectedJob, candidateCurrentStatus, fromDate, or toDate changes
  useEffect(() => {
    fetchData();
  }, [selectedJob, candidateCurrentStatus]);

  // useEffect(() => {
  //   fetchData();
  // }, [selectedJob, candidateCurrentStatus, fromDate, toDate]);

  const handleClearOptions = () => {
    setSelectedJob("");
    // setFromDate("");
    // setToDate("");
    setCandidateCurrentStatus("");
    fetchData();
  };

  useEffect(() => {
    // Fetch JD options (job_description_id and job_description_role)
    const fetchJobDescriptions = async () => {
      const storedClient = localStorage.getItem("client");
      const storedUser = localStorage.getItem("user_id");

      // Convert stored values to numbers
      const client_id = storedClient ? Number(storedClient) : null;
      const user_id = storedUser ? Number(storedUser) : null;

      // Debugging: Log retrieved values
      console.log("Fetching data with:", { client_id, user_id });

      // Ensure client_id and user_id are valid before making the request
      if (!client_id || !user_id) {
        console.error("Missing client_id or user_id. Please log in again.");
        return;
      }
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/screener/resumes-candidates?client_id=${client_id}&user_id=${user_id}`
        );
        const result = await response.json();
        const jobOptions = result.map((item) => ({
          id: item.job_description_id,
          role: item.job_description_role,
          label: `JD ID: ${item.job_description_id}, Role: ${item.job_description_role}`,
        }));
        const uniqueJobOptions = [
          ...new Map(jobOptions.map((item) => [item.label, item])).values(),
        ];
        setJobDescriptionOptions(uniqueJobOptions);
      } catch (err) {
        console.error("Error fetching job descriptions", err);
      }
    };
    fetchJobDescriptions();
  }, []);

  useEffect(() => {
    // Fetch candidate statuses
    const fetchCandidateStatuses = async () => {
      const storedClient = localStorage.getItem("client");
      const storedUser = localStorage.getItem("user_id");

      // Convert stored values to numbers
      const client_id = storedClient ? Number(storedClient) : null;
      const user_id = storedUser ? Number(storedUser) : null;

      // Debugging: Log retrieved values
      console.log("Fetching data with:", { client_id, user_id });

      // Ensure client_id and user_id are valid before making the request
      if (!client_id || !user_id) {
        console.error("Missing client_id or user_id. Please log in again.");
        return;
      }
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/screener/resumes-candidates?client_id=${client_id}&user_id=${user_id}`
        );
        const result = await response.json();
        const statuses = [
          ...new Set(
            result.map((item) => item.candidate_current_status).filter(Boolean)
          ),
        ];
        setCandidateCurrentStatuses(statuses);
      } catch (err) {
        console.error("Error fetching candidate statuses", err);
      }
    };
    fetchCandidateStatuses();
  }, []);

  if (loading) {
    return (
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div>
          <div
            className="spinner-border text-dark"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <h3 className="text-center text-dark">&nbsp;Data is Fetching.... </h3>
      </div>
    );
  }

  if (error) return <div className="error">{error.message}</div>;

  return (
    <>
      <DashboardNavbar />
      <div className="container py-3 main-content">
        <div className="text-center mb-1 font_header">
          <h1>Summary Report</h1>
        </div>

        <div className="row align-items-center">
          <div className="col-sm-12 mt-2 mb-4 text-gred">
            <div className="d-flex align-items-start justify-content-between">
              <form className="row g-3 align-items-center flex-grow-1 fw-bold">
                <div className="col-lg-4 col-md-5 mb-1">
                  <label
                    htmlFor="jobDescription"
                    className="form-label text-dark"
                  >
                    Search by JD ID / Role:
                  </label>
                  <div className="d-flex align-items-center">
                    <select
                      className="form-select select-box border-dark"
                      id="jobDescription"
                      title="Search By JD ID / Role"
                      aria-label="Job Description ID / Role"
                      value={selectedJob}
                      onChange={(e) => setSelectedJob(e.target.value)}
                    >
                      <option value="" disabled>
                        Select a JD ID / Role
                      </option>
                      {jobDescriptionOptions.map((option, index) => (
                        <option
                          key={index}
                          value={`${option.id}, ${option.role}`}
                        >
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-lg-3 col-md-5 mb-1">
                  <label
                    htmlFor="candidateCurrentStatus"
                    className="form-label"
                  >
                    Search By Candidate Status:
                  </label>
                  <div className="d-flex align-items-center">
                    <select
                      className="form-select select-box border-dark"
                      id="candidateCurrentStatus"
                      title="Search By Candidate Status"
                      aria-label="Candidate Current Status"
                      value={candidateCurrentStatus}
                      onChange={(e) =>
                        setCandidateCurrentStatus(e.target.value)
                      }
                    >
                      <option value="" disabled>
                        Select a Status
                      </option>
                      {candidateCurrentStatuses.map((status, index) => (
                        <option key={index} value={status}>
                          {status}
                        </option>
                      ))}
                    </select>
                    <button
                      type="button"
                      className="btn btn-outline-danger ms-2"
                      title="Clear All"
                      onClick={handleClearOptions}
                    >
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                </div>

                {/* <div className="col-lg-2 col-md-5 mb-1">
                  <label htmlFor="fromDate" className="form-label text-dark">
                    From Date:
                  </label>
                  <input
                    className="form-control border-dark bg-transparent"
                    type="date"
                    id="fromDate"
                    title="From Date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </div>

                <div className="col-lg-2 col-md-5 mb-1">
                  <label htmlFor="toDate" className="form-label text-dark">
                    To Date:
                  </label>
                  <div className="d-flex">
                    <input
                      className="form-control border-dark bg-transparent"
                      type="date"
                      id="toDate"
                      title="To Date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-danger ms-2"
                      title="Clear All"
                      onClick={handleClearOptions}
                    >
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                </div> */}
              </form>
            </div>
          </div>
        </div>

        {/* <div className="row">
          <div className="col-md-3 mb-4">
            <div className="card text-center text-white">
              <div
                className="card-header fw-bold"
                style={{ background: "#008cba" }}
              >
                Total Processed JDs
              </div>
              <div className="card-body">
                <Link to="/reports_dashboard" className="card-link">
                  {data.processedJDs}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="card text-center text-white">
              <div
                className="card-header fw-bold"
                style={{ background: "#008cba" }}
              >
                Total Resumes Screened
              </div>
              <div className="card-body">
                <Link to="/reports_dashboard" className="card-link">
                  {data.resumesScreened}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="card text-center text-white">
              <div
                className="card-header fw-bold"
                style={{ background: "#008cba" }}
              >
                No of L1 Interviews
              </div>
              <div className="card-body">
                <Link
                  to={`/reports_dashboard?candidate_status=l1_scheduled`}
                  className="card-link"
                >
                  {data.L1Interviews}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="card text-center text-white">
              <div
                className="card-header fw-bold"
                style={{ background: "#008cba" }}
              >
                No of L2 Interviews
              </div>
              <div className="card-body">
                <Link
                  to={`/reports_dashboard?candidate_status=l2_scheduled`}
                  className="card-link"
                >
                  {data.L2Interviews}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="card text-center text-white">
              <div
                className="card-header fw-bold"
                style={{ background: "#008cba" }}
              >
                No of L3 Interviews
              </div>
              <div className="card-body">
                <Link
                  to={`/reports_dashboard?candidate_status=l3_scheduled`}
                  className="card-link"
                >
                  {data.L3Interviews}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="card text-center text-white">
              <div
                className="card-header fw-bold"
                style={{ background: "#008cba" }}
              >
                No of HR Interviews
              </div>
              <div className="card-body">
                <Link
                  to={`/reports_dashboard?candidate_status=hr_scheduled`}
                  className="card-link"
                >
                  {data.hrInterviews}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="card text-center text-white">
              <div
                className="card-header fw-bold"
                style={{ background: "#008cba" }}
              >
                No of Offers Released
              </div>
              <div className="card-body">
                <Link
                  to={`/reports_dashboard?candidate_status=offer_accepted`}
                  className="card-link"
                >
                  {data.offersReleased}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="card text-center text-white">
              <div
                className="card-header fw-bold"
                style={{ background: "#008cba" }}
              >
                No of Candidates Joined
              </div>
              <div className="card-body">
                <Link
                  to={`/reports_dashboard?candidate_status=joined`}
                  className="card-link"
                >
                  {data.candidatesJoined}
                </Link>
              </div>
            </div>
          </div>
        </div> */}
        <div className="row">
          <div className="col-md-3 mb-4">
            <div className="custom-card text-center text-white animate__animated animate__fadeInUp">
              <div className="custom-card-header fw-bold">
                Total Processed JDs
              </div>
              <div className="custom-card-body">
                <Link to="/reports_dashboard" className="custom-card-link">
                  {data.processedJDs}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="custom-card text-center text-white animate__animated animate__fadeInUp">
              <div className="custom-card-header fw-bold">
                Total Resumes Screened
              </div>
              <div className="custom-card-body">
                <Link to="/reports_dashboard" className="custom-card-link">
                  {data.resumesScreened}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="custom-card text-center text-white animate__animated animate__fadeInUp">
              <div className="custom-card-header fw-bold">
                No of L1 Interviews
              </div>
              <div className="custom-card-body">
                <Link
                  to={`/reports_dashboard?metric_key=l1_scheduled`}
                  className="custom-card-link"
                >
                  {data.L1Interviews}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="custom-card text-center text-white animate__animated animate__fadeInUp">
              <div className="custom-card-header fw-bold">
                No of L2 Interviews
              </div>
              <div className="custom-card-body">
                <Link
                  to={`/reports_dashboard?metric_key=l2_scheduled`}
                  className="custom-card-link"
                >
                  {data.L2Interviews}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="custom-card text-center text-white animate__animated animate__fadeInUp">
              <div className="custom-card-header fw-bold">
                No of L3 Interviews
              </div>
              <div className="custom-card-body">
                <Link
                  to={`/reports_dashboard?metric_key=l3_scheduled`}
                  className="custom-card-link"
                >
                  {data.L3Interviews}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="custom-card text-center text-white animate__animated animate__fadeInUp">
              <div className="custom-card-header fw-bold">
                No of HR Interviews
              </div>
              <div className="custom-card-body">
                <Link
                  to={`/reports_dashboard?metric_key=hr_scheduled`}
                  className="custom-card-link"
                >
                  {data.hrInterviews}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="custom-card text-center text-white animate__animated animate__fadeInUp">
              <div className="custom-card-header fw-bold">
                No of Offers Released
              </div>
              <div className="custom-card-body">
                <Link
                  to={`/reports_dashboard?metric_key=offer_accepted`}
                  className="custom-card-link"
                >
                  {data.offersReleased}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <div className="custom-card text-center text-white animate__animated animate__fadeInUp">
              <div className="custom-card-header fw-bold">
                No of Candidates Joined
              </div>
              <div className="custom-card-body">
                <Link
                  to={`/reports_dashboard?metric_key=joined`}
                  className="custom-card-link"
                >
                  {data.candidatesJoined}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SummaryReport;
